"use client";

import { useEffect, useRef, useState } from "react";

import {
  GAM_HOME_DESKTOP_LEFT_RAIL_AD_UNIT,
  GAM_HOME_DESKTOP_RAIL_ENABLED,
  GAM_HOME_DESKTOP_RAIL_MIN_HEIGHT,
  GAM_HOME_DESKTOP_RAIL_SIZES,
  GAM_HOME_DESKTOP_RIGHT_RAIL_AD_UNIT,
} from "@/components/ads/config";

import GamDisplaySlot from "./GamDisplaySlot";
import styles from "./HomeDesktopRails.module.css";

const DESKTOP_RAIL_QUERY = "(min-width: 1680px)";
const HEADER_OFFSET = 112;

export default function HomeDesktopRails() {
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [showRails, setShowRails] = useState(false);

  useEffect(() => {
    if (!GAM_HOME_DESKTOP_RAIL_ENABLED) return undefined;

    const mediaQuery = window.matchMedia(DESKTOP_RAIL_QUERY);

    const update = () => {
      const anchor = anchorRef.current;
      if (!anchor || !mediaQuery.matches) {
        setShowRails(false);
        return;
      }

      const anchorTop = anchor.getBoundingClientRect().top + window.scrollY;
      setShowRails(window.scrollY + HEADER_OFFSET >= anchorTop);
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    mediaQuery.addEventListener("change", update);

    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      mediaQuery.removeEventListener("change", update);
    };
  }, []);

  return (
    <>
      <div ref={anchorRef} className={styles.anchor} aria-hidden="true" />

      {GAM_HOME_DESKTOP_RAIL_ENABLED && showRails ? (
        <aside className={styles.rails} aria-label="Sponsored homepage side banners">
          <div className={`${styles.rail} ${styles.left}`}>
            <div className={styles.header}>
              <span className={styles.label}>Sponsored</span>
            </div>
            <GamDisplaySlot
              id="home-desktop-left-rail"
              adUnit={GAM_HOME_DESKTOP_LEFT_RAIL_AD_UNIT}
              sizes={[...GAM_HOME_DESKTOP_RAIL_SIZES]}
              minHeight={GAM_HOME_DESKTOP_RAIL_MIN_HEIGHT}
              targeting={{
                page_type: "home",
                device: "desktop",
                placement: "home_desktop_left_rail_after_hero",
                position: "left_rail_after_hero",
              }}
            />
          </div>

          <div className={`${styles.rail} ${styles.right}`}>
            <div className={styles.header}>
              <span className={styles.label}>Sponsored</span>
            </div>
            <GamDisplaySlot
              id="home-desktop-right-rail"
              adUnit={GAM_HOME_DESKTOP_RIGHT_RAIL_AD_UNIT}
              sizes={[...GAM_HOME_DESKTOP_RAIL_SIZES]}
              minHeight={GAM_HOME_DESKTOP_RAIL_MIN_HEIGHT}
              targeting={{
                page_type: "home",
                device: "desktop",
                placement: "home_desktop_right_rail_after_hero",
                position: "right_rail_after_hero",
              }}
            />
          </div>
        </aside>
      ) : null}
    </>
  );
}
